import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon, ShieldIcon, StarIcon } from '../components/Icons';
import './About.css';

const About: React.FC = () => (
  <main className="about-page">
    {/* HERO */}
    <section className="about-hero">
      <div className="about-hero__overlay" />
      <img
        className="about-hero__bg"
        src="https://images.unsplash.com/photo-1494412574643-ff11b0a5c1c3?w=1600&q=80"
        alt="Logistics operations"
      />
      <div className="container about-hero__content">
        <p className="section-label">Our Story</p>
        <h1 className="about-hero__title">Established in Accra,<br />Delivering to the World.</h1>
      </div>
    </section>

    {/* MISSION */}
    <section className="about-mission">
      <div className="container about-mission__grid">
        <div>
          <p className="section-label">Who We Are</p>
          <h2 className="section-title">Built on Trust.<br />Driven by Precision.</h2>
          <p style={{ fontSize: 15, color: 'var(--gray-dark)', lineHeight: 1.7, marginTop: 20, maxWidth: 500 }}>
            Droff Logistics was founded with one goal: make cargo movement across Ghana and beyond as reliable as any world-class logistics company. From a single hub in East Legon, Accra, we now serve clients across the continent and internationally.
          </p>
          <p style={{ fontSize: 15, color: 'var(--gray-dark)', lineHeight: 1.7, marginTop: 16, maxWidth: 500 }}>
            Every shipment we handle is backed by technology, trained handlers, and a support team reachable 24/7. We don't just move packages — we move businesses forward.
          </p>
        </div>
        <div className="about-mission__values">
          <div className="about-value-card">
            <span className="about-value-card__icon"><HeartIcon size={26} strokeWidth={1.6} /></span>
            <div>
              <h3 className="about-value-card__title">Passion</h3>
              <p className="about-value-card__desc">We care about every package as if it is our own.</p>
            </div>
          </div>
          <div className="about-value-card">
            <span className="about-value-card__icon"><ShieldIcon size={26} strokeWidth={1.6} /></span>
            <div>
              <h3 className="about-value-card__title">Integrity</h3>
              <p className="about-value-card__desc">Honest pricing, transparent tracking, no surprises.</p>
            </div>
          </div>
          <div className="about-value-card">
            <span className="about-value-card__icon"><StarIcon size={26} strokeWidth={1.6} /></span>
            <div>
              <h3 className="about-value-card__title">Excellence</h3>
              <p className="about-value-card__desc">Industry-leading SLAs and a 99.2% on-time delivery rate.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* STATS */}
    <section className="about-stats">
      <div className="container about-stats__grid">
        {[
          { num: '500+', label: 'Deliveries per day' },
          { num: '16', label: 'Regions covered in Ghana' },
          { num: '99.2%', label: 'On-time delivery rate' },
          { num: '24/7', label: 'Customer support' },
        ].map(s => (
          <div key={s.label} className="about-stat">
            <span className="about-stat__num">{s.num}</span>
            <span className="about-stat__label">{s.label}</span>
          </div>
        ))}
      </div>
    </section>

    {/* HEADQUARTERS */}
    <section className="about-hq">
      <div className="container about-hq__inner">
        <p className="section-label">Headquarters</p>
        <h2 className="section-title">Find Us in Accra</h2>
        <p style={{ fontSize: 15, color: 'var(--gray-dark)', marginTop: 12, marginBottom: 32 }}>
          No. 5 Numo Tetteh Kwao St, Adjiriganor, East Legon, Accra, Ghana
        </p>
        <Link to="/contact" className="btn-primary">Get in Touch</Link>
      </div>
    </section>

    {/* CTA */}
    <section style={{ background: 'var(--red)', padding: '72px 0' }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap' }}>
        <h2 style={{ fontSize: 'clamp(22px,3vw,34px)', fontWeight: 700, color: '#fff', maxWidth: 480 }}>
          Ready to experience kinetic precision?
        </h2>
        <div style={{ display: 'flex', gap: 16 }}>
          <Link to="/contact" className="btn-primary" style={{ background: '#fff', color: 'var(--red)', borderColor: '#fff' }}>Get a Quote</Link>
          <Link to="/contact" className="btn-outline">Contact Sales</Link>
        </div>
      </div>
    </section>
  </main>
);

export default About;
